// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Exception from "../Effect.Exception/index.js";
import * as Effect_Timer from "../Effect.Timer/index.js";
import * as Web_DOM_Document from "../Web.DOM.Document/index.js";
import * as Web_DOM_Element from "../Web.DOM.Element/index.js";
import * as Web_DOM_Node from "../Web.DOM.Node/index.js";
import * as Web_DOM_NodeList from "../Web.DOM.NodeList/index.js";
import * as Web_DOM_ParentNode from "../Web.DOM.ParentNode/index.js";
import * as Web_Event_EventTarget from "../Web.Event.EventTarget/index.js";
import * as Web_HTML from "../Web.HTML/index.js";
import * as Web_HTML_HTMLDocument from "../Web.HTML.HTMLDocument/index.js";
import * as Web_HTML_HTMLDocument_ReadyState from "../Web.HTML.HTMLDocument.ReadyState/index.js";
import * as Web_HTML_Window from "../Web.HTML.Window/index.js";
var wrap = /* #__PURE__ */ Data_Newtype.wrap();
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Effect.functorEffect);
var bind = /* #__PURE__ */ Control_Bind.bind(Effect.bindEffect);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var $$void = /* #__PURE__ */ Data_Functor["void"](Effect.functorEffect);
var show = /* #__PURE__ */ $foreign.removeClass("hide");
var removeChildren = /* #__PURE__ */ $foreign.setInnerHtml("");
var querySelectorAll$prime = function (selector) {
    return function (element) {
        var result = Web_DOM_ParentNode.querySelectorAll(wrap(selector))(Web_DOM_Element.toParentNode(element));
        return mapFlipped(mapFlipped(bind(result)(Web_DOM_NodeList.toArray))(map(Web_DOM_Element.fromNode)))(Data_Array.catMaybes);
    };
};
var querySelector$prime = function (selector) {
    return function (element) {
        return Web_DOM_ParentNode.querySelector(wrap(selector))(Web_DOM_Element.toParentNode(element));
    };
};
var querySelectorOrThrow = function (selector) {
    return function (element) {
        return function __do() {
            var maybeElement = querySelector$prime(selector)(element)();
            if (maybeElement instanceof Data_Maybe.Just) {
                return maybeElement.value0;
            };
            if (maybeElement instanceof Data_Maybe.Nothing) {
                return Effect_Exception["throw"]("Couldn't select " + selector)();
            };
            throw new Error("Failed pattern match at Utils.DOM (line 83, column 3 - line 85, column 54): " + [ maybeElement.constructor.name ]);
        };
    };
};
var parentNode$prime = function (node) {
    return function __do() {
        var maybeParent = Web_DOM_Node.parentNode(node)();
        var maybeNode = bind1(maybeParent)(Web_DOM_Element.fromNode);
        if (maybeNode instanceof Data_Maybe.Nothing) {
            return Effect_Exception["throw"]("Parent not found")();
        };
        if (maybeNode instanceof Data_Maybe.Just) {
            return maybeNode.value0;
        };
        throw new Error("Failed pattern match at Utils.DOM (line 112, column 3 - line 114, column 31): " + [ maybeNode.constructor.name ]);
    };
};
var hide = /* #__PURE__ */ $foreign.addClass("hide");
var globalQuerySelectorAll = function (selector) {
    return function __do() {
        var doc = bind(Web_HTML.window)(Web_HTML_Window.document)();
        var result = Web_DOM_ParentNode.querySelectorAll(wrap(selector))(Web_DOM_Document.toParentNode(Web_HTML_HTMLDocument.toDocument(doc)));
        return mapFlipped(mapFlipped(bind(result)(Web_DOM_NodeList.toArray))(map(Web_DOM_Element.fromNode)))(Data_Array.catMaybes)();
    };
};
var globalQuerySelector = function (selector) {
    return function __do() {
        var doc = bind(Web_HTML.window)(Web_HTML_Window.document)();
        return Web_DOM_ParentNode.querySelector(wrap(selector))(Web_DOM_Document.toParentNode(Web_HTML_HTMLDocument.toDocument(doc)))();
    };
};
var ensureExistance = function (errorMsg) {
    return function (maybeEl) {
        if (maybeEl instanceof Data_Maybe.Nothing) {
            return Effect_Exception["throw"](errorMsg);
        };
        if (maybeEl instanceof Data_Maybe.Just) {
            return pure(maybeEl.value0);
        };
        throw new Error("Failed pattern match at Utils.DOM (line 69, column 3 - line 71, column 23): " + [ maybeEl.constructor.name ]);
    };
};
var closest = /* #__PURE__ */ (function () {
    return $foreign.closestImpl(Data_Maybe.Just.create)(Data_Maybe.Nothing.value);
})();
var appendChild$prime = function (child) {
    return function (root) {
        return Web_DOM_Node.appendChild(Web_DOM_Element.toNode(child))(Web_DOM_Element.toNode(root));
    };
};
var addEventListenerImpl = function (eventType) {
    return function (eventListener) {
        return function (eventTarget) {
            return Web_Event_EventTarget.addEventListener(wrap(eventType))(eventListener)(true)(eventTarget);
        };
    };
};
var executeWhenLoaded = function (listenerFunction) {
    return function __do() {
        var win = Web_HTML.window();
        var doc = Web_HTML_Window.document(win)();
        var state = Web_HTML_HTMLDocument.readyState(doc)();
        var listener = Web_Event_EventTarget.eventListener(Data_Function["const"](listenerFunction))();
        if (state instanceof Web_HTML_HTMLDocument_ReadyState.Loading) {
            return addEventListenerImpl("DOMContentLoaded")(listener)(Web_HTML_HTMLDocument.toEventTarget(doc))();
        };
        return $$void(Effect_Timer.setTimeout(0)(listenerFunction))();
    };
};
var addEventListener$prime = function (eventType) {
    return function (listener) {
        return function (element) {
            return addEventListenerImpl(eventType)(listener)(Web_DOM_Element.toEventTarget(element));
        };
    };
};
export {
    addClass,
    removeClass,
    hasClass,
    getData,
    setData,
    setInnerHtml,
    setInnerText,
    focus,
    getValue,
    parents,
    closestImpl,
    queueMicrotask,
    addTestLoadedMarker,
    logErrorOnElement
} from "./foreign.js";
export {
    closest,
    removeChildren,
    show,
    hide,
    addEventListenerImpl,
    ensureExistance,
    querySelector$prime,
    querySelectorOrThrow,
    globalQuerySelector,
    querySelectorAll$prime,
    globalQuerySelectorAll,
    parentNode$prime,
    addEventListener$prime,
    executeWhenLoaded,
    appendChild$prime
};
